import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import cvodR13 from '../../../images/cvod/cvod-13.svg'
import cvodRR13 from '../../../images/cvod/cvod-R13.svg'
import cvodRP13 from '../../../images/cvod/cvod-RP13.svg'
import cvodRR15 from '../../../images/cvod/cvod-R15.svg'
import cvodRP15 from '../../../images/cvod/cvod-RP15.svg'
import cvodR16 from '../../../images/cvod/cvod-16.svg'
import cvodRR16 from '../../../images/cvod/cvod-R16.svg'
import cvodRP16 from '../../../images/cvod/cvod-RP16.svg'
import cvodR18 from '../../../images/cvod/cvod-18.svg'
import cvodRR18 from '../../../images/cvod/cvod-R18.svg'
import cvodRP18 from '../../../images/cvod/cvod-RP18.svg'
import cvodG from '../../../images/cvod/cvod-g.svg'
import cvodM from '../../../images/cvod/cvod-m.svg'
import cvodPG from '../../../images/cvod/cvod-pg.svg'
import styles from './rating.css'

const smallSize = '25px'
const mediumSize = '30px'
const largeSize = '55px'
const xlargeSize = '75px'

const getIcon = value => {
  switch (value) {
    case 'G':
      return cvodG
    case 'PG':
      return cvodPG
    case 'M':
      return cvodM
    case 'R13':
      return cvodR13
    case 'RP13':
      return cvodRP13
    case 'RR13':
      return cvodRR13
    case 'RP15':
      return cvodRP15
    case 'RR15':
      return cvodRR15
    case 'R16':
      return cvodR16
    case 'RP16':
      return cvodRP16
    case 'RR16':
      return cvodRR16
    case 'R18':
      return cvodR18
    case 'RP18':
      return cvodRP18
    case 'RR18':
      return cvodRR18
    default:
      return null
  }
}

export const Rating = ({
  size = 'small',
  rating,
  showReason,
  className,
  isInPlayer
}) => {
  const icon = getIcon(rating.rating)

  let width = ''
  let height = ''

  if (size === 'small') {
    width = smallSize
    height = smallSize
  } else if (size === 'medium') {
    width = mediumSize
    height = mediumSize
  } else if (size === 'large') {
    width = largeSize
    height = largeSize
  } else if (size === 'xlarge') {
    width = xlargeSize
    height = xlargeSize
  }

  return (
    <div className={classNames(className, styles.iconEffect)}>
      <img
        src={icon}
        width={width}
        height={height}
        className={classNames({
          [styles.iconInPlayer]: isInPlayer
        })}
      />
      {showReason && rating.reason && <p>{rating.reason}</p>}
    </div>
  )
}

Rating.propTypes = {
  rating: PropTypes.shape({
    rating: PropTypes.string.isRequired,
    reason: PropTypes.string
  }).isRequired,
  showReason: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired, // small, medium and large
  className: PropTypes.string,
  isInPlayer: PropTypes.bool
}
